<template>
    <transition name="fade">
        <div id="visit-card">
            <div class="tips-action">
                Cliquez sur<br> la carte de la visite
                <img src="@/assets/svg/hand_up.svg"
                     alt="Symbole en forme de main indiquant l'endroit où l'utilisateur dois intéragir">
            </div>
            <div class="transparent-action" @click="emit"></div>
        </div>
    </transition>
</template>
<script>
    export default {
        name: 'VisitCard',
        methods: {
            emit() {
                this.state = false
                this.$emit('go')
            }
        }
    }
</script>
<style lang="scss" scoped>
    #visit-card {
        .tips-action {
            text-align: center;
            font-size: 1.875rem;
            color: #fff;
            font-family: 'Roboto Condensed', sans-serif;
            position: absolute;
            width: 23%;
            height: 28%;
            top: 55%;
            left: 60%;
            img {
                width: 20%;
                display: block;
                margin: 20px auto auto auto;
                animation: hand-animation 700ms ease-in-out infinite alternate;
            }
            @keyframes hand-animation {
                0% {
                    transform: translateY(0px);
                }
                100% {
                    transform: translateY(20px);
                }
            }
        }

        .transparent-action {
            width: 4%;
            height: 4%;
            top: 87%;
            left: 70%;
            background-color: transparent;
            -webkit-transform: rotateZ(-2deg);
            transform: skew(65deg, -20deg);
            cursor: pointer;
            position: absolute;
        }
    }

</style>

